import { useState } from "react";
import {
  Stack,
  Typography,
  TextField,
  Button,
  IconButton,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

const KeyValueEditor = ({
  title,
  store,
  addCustomValue,
  updateKey,
  updateValue,
  removeKey,
  handleSnack,
}) => {
  const [newKey, setNewKey] = useState("");
  const [newValue, setNewValue] = useState("");

  const handleAdd = (event) => {
    event.preventDefault();
    addCustomValue(newKey, newValue, handleSnack);
    setNewKey("");
    setNewValue("");
  };

  return (
    <>
      <Typography className="stacked-label" variant="h6">
        {title}
      </Typography>
      <Stack direction="row" spacing={1}>
        <TextField
          label="Agregar llave"
          variant="outlined"
          value={newKey}
          onChange={(event) => setNewKey(event.target.value)}
          size="small"
        />
        <TextField
          label="Agregar valor"
          variant="outlined"
          value={newValue}
          onChange={(event) => setNewValue(event.target.value)}
          size="small"
        />
        <Button
          onClick={handleAdd}
          className="stacked-webhook-button"
          variant="contained"
          size="small"
        >
          Agregar
        </Button>
      </Stack>

      {store.map((item) => (
        <Stack direction="row" spacing={1} key={item.id}>
          <TextField
            label="Llave"
            variant="outlined"
            value={item.key}
            onChange={(event) => updateKey(item.id, event.target.value)}
            size="small"
          />
          <TextField
            label="Valor"
            variant="outlined"
            value={item.value}
            onChange={(event) => updateValue(item.id, event.target.value)}
            size="small"
          />
          <IconButton
            className="staked-delete-button"
            color="error"
            onClick={() => removeKey(item.id)}
            size="small"
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Stack>
      ))}
    </>
  );
};

export default KeyValueEditor;
